import { Box, InputBase, styled, Theme, Typography } from '@mui/material';

export const IncrementDecrementContainer = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  border: `1px solid ${theme.palette.gray.mediumLight}`,
  borderRadius: theme.shape.borderRadius,
  display: 'flex',
  justifyContent: 'space-between',
  width: '50%',
}));

export const getToggleButtonSx = (theme: Theme) => ({
  borderRadius: theme.spacing(1),
  padding: theme.spacing(2),
  height: '42px',
  marginBottom: theme.spacing(4),
  border: `1px solid ${theme.palette.gray.mediumLight}`,
});

export const Right = styled(Box)({
  width: '50%',
});

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: theme.spacing(1),
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: theme.spacing(1),
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('sm')]: {
      width: 'inherit',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

export const UnsureVacancyInfoText = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(1),
  fontSize: theme.typography.body3.fontSize,
  color: theme.palette.gray.medium,
  lineHeight: theme.spacing(1.75),
  fontStyle: 'italic',
  width: '50%',
}));

export const VacancyCTAContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  paddingTop: theme.spacing(3),
  justifyContent: 'flex-end',
}));

export const VacancyModalTitle = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.text.primary,
}));

export const getVacanciesModalBodySx = (theme) => ({
  borderRadius: theme.shape.borderRadius,
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '90vh',
  maxWidth: '900px',
  padding: theme.spacing(4),
  width: '80%',
  [theme.breakpoints.up('xs')]: {
    width: '90%',
  },
  [theme.breakpoints.up('md')]: {
    width: '90%',
  },
});
